import SurveyQuestionType from '../../../shared/models/survey/SurveyQuestionType';
import SurveyQuestions from '../components/surveyQuestions/SurveyQuestions';
import useSurveyContext from '../store/UseSurveyContext';

import './Survey.scss';

const SurveyPage = () => {
  const { question } = useSurveyContext();

  const { questionType } = question || {};
  const hasBackground =
    questionType === SurveyQuestionType.CHAPTER_INTRODUCTION || questionType === SurveyQuestionType.INTRODUCTION;

  return (
    <section className={`step ${hasBackground ? 'chapter-intro' : 'chapter-question'}`}>
      <div className="survey-page">
        <SurveyQuestions />
      </div>
    </section>
  );
};
export default SurveyPage;
